// libraries
import { forwardRef } from 'react';
import { Form, FormInstance, FormProps } from 'antd';
import styled from 'styled-components';

export const SearchForm = forwardRef<FormInstance, FormProps>((props, ref) => {
	return <StyledForm size="small" layout="inline" {...props} ref={ref} />;
});

const StyledForm = styled(Form)`
	width: 100%;
	padding: 1ch;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	gap: 1ch;
	border-bottom: 1px solid #f0f0f0;

	.ant-form-item {
		margin: 0;
	}
`;
